export default __webpack_public_path__ + "static/media/mutual-ic-star-filled.f47a0478.svg";